var map = {
	"./blog/1/polkadot.png": 701,
	"./blog/1/real_estate.jpg": 957,
	"./blog/2/team.jpg": 590,
	"./news/1/polkadot.png": 301,
	"./news/1/real_estate.jpg": 168,
	"./news/2/team.jpg": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;